import { Seo } from "@/components/site/Seo";
import { useCustomer } from "@/context/CustomerContext";
import { WalletPanel } from "@/components/account/WalletPanel";

export default function WalletPage() {
  const { customer, reload } = useCustomer();
  return (
    <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8" data-testid="wallet-page">
      <Seo title="محفظتي" noindex />
      <h1 className="font-display mb-8 text-4xl text-white sm:text-5xl">محفظتي</h1>
      <WalletPanel balance={customer.wallet_balance} tick={customer.wallet_balance} onChange={reload} />
    </div>
  );
}
